import { defineSlotRecipe } from '@chakra-ui/react';

export const radioSlotRecipe = defineSlotRecipe({
  className: 'chakra-radio',
  slots: ['root', 'item', 'itemIndicator', 'indicator', 'label', 'itemText', 'itemControl', 'itemAddon'],
  base: {
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      gap: 3,
      _disabled: {
        cursor: 'default',
      },
    },
    item: {
      width: '100%',
      gap: 2,
      cursor: 'pointer',
      '&&[data-state="checked"]': {
        cursor: 'default',
      },
      _disabled: {
        cursor: 'default',
      },
    },
    itemText: {
      textStyle: 'sm',
      lineHeight: '24px',
      marginLeft: 0,
      _disabled: {
        opacity: 1,
      },
    },
    itemControl: {
      width: '20px',
      height: '20px',
      background: 'transparent',
      border: '2px solid',
      color: 'neutral.300',
      borderColor: 'neutral.500',
      position: 'relative',
      cursor: 'pointer',
      _focusVisible: {
        boxShadow: 'none !important',
      },
      '&&[data-state="checked"]': {
        background: 'blue.700',
        borderColor: 'blue.500',
        color: 'skyBlue.500',
        cursor: 'default',
        _disabled: {
          background: 'transparent',
          borderColor: 'neutral.600',
          color: 'neutral.600',
        },
      },
      '&:hover:not([data-state="checked"])': {
        borderColor: 'skyBlue',
        background: 'blue.600',
      },
      _disabled: {
        cursor: 'default',
        background: 'transparent',
        borderColor: 'neutral.600',
        color: 'neutral.600',
        _hover: {
          color: 'neutral.600',
          backgroundColor: 'transparent',
          borderColor: 'neutral.600',
        },
      },
      '& .dot': {
        height: '10px',
        width: '10px',
        borderRadius: 'full',
        scale: 1,
        backgroundColor: 'currentColor',
      },
    },
  },
  variants: {
    size: {
      sm: {
        item: {
          textStyle: 'sm',
        },
        root: {
          gap: 3,
        },
        itemText: {
          textStyle: 'sm',
        },
      },
      screenStd: {
        item: {
          textStyle: 'screenStd',
        },
        root: {
          gap: 'standardS',
        },
        itemText: {
          textStyle: 'screenStd',
        },
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});
